module.exports = __webpack_public_path__ + "img/BlogPost1b.9a02a3f5.jpg";